<template>
  <div class="history">
      <template>

        <v-form
          ref="classroom-form"
          :value="classroomValid"
          lazy-validation
        >
          <v-row class="mx-3">
            <v-col cols="3" class="mt-0 pt-0 pb-0">
              <v-text-field
                v-model="code"
                label="お客様No."
                disabled
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="mx-6 mb-1">
            <v-col cols="12" class="pl-0 mt-0 pt-0">
              <v-textarea
                v-model="name"
                disabled
                label="塾名"
                rows=2
                no-resize
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mx-6 mb-1">
            <v-col cols="12" class="pl-0 mt-0 pt-0">
              <v-textarea
                v-model="className"
                :counter="50"
                label="教室名"
                :rules="rules.classroomName"
                :disabled="!useStatus"
                rows=2
                no-resize
              >
                <template #[`label`]>
                  教室名 <font color="red">❇︎</font>
                </template>
              </v-textarea>
            </v-col>
          </v-row>

          <fieldset>
            <legend>ログイン情報</legend>
            <v-row class="mx-6">
              <v-col cols="5">
                <v-text-field
                  v-model="loginId"
                  :counter="30"
                  label="ログインID"
                  :rules="rules.loginId"
                  :disabled="!useStatus"
                >
                  <template #[`label`]>
                    ログインID <font color="red">❇︎</font>
                  </template>
                </v-text-field>
                <v-btn small color="secondary" @click="randomGenerate('loginId')" :disabled="!useStatus">ログインID自動生成</v-btn>
              </v-col>
              <v-col cols="5" class="ml-4">
                <v-text-field
                  v-model="password"
                  :counter="30"
                  :label="passwordLabel"
                  :rules="passwordRules"
                  :disabled="!useStatus"
                >
                  <template #[`label`] v-if="!$store.state.account.id">
                    パスワード <font color="red">❇︎</font>
                  </template>
                </v-text-field>
                <v-btn small color="secondary" @click="randomGenerate('password')" :disabled="!useStatus">パスワード自動生成</v-btn>
                <v-checkbox
                  label="メール送信"
                  color="secondary"
                  v-model="sendMail"
                  hide-details
                  dense
                  :disabled="!useStatus"
                />
              </v-col>
            </v-row>
          </fieldset>

          <fieldset class="mt-10">
            <legend>契約情報</legend>
            <v-row class="mx-6 mb-2">
              <v-col cols="5">
                <template v-if="useStatus">
                  <DateTimePicker
                    v-model="startDate"
                    title="利用開始日時"
                    required
                    :valid="startDateValid"
                  ></DateTimePicker>
                </template>
                <template v-else>
                  <v-text-field
                    prepend-icon="mdi-calendar"
                    :value="displayStartDate"
                    label="利用開始日時"
                    disabled
                  ></v-text-field>
                </template>
                <div class="mt-2 v-text-field__details" v-if="!startDateValid">
                  <div class="v-messages theme--light error--text" role="alert">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">利用開始日時を入力してください</div>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="5" class="ml-4">
                <template v-if="useStatus">
                  <DateTimePicker
                    v-model="endDate"
                    end
                    title="利用終了日時"
                  ></DateTimePicker>
                </template>
                <template v-else>
                  <v-text-field
                    prepend-icon="mdi-calendar"
                    :value="displayEndDate"
                    label="利用終了日時"
                    disabled
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
            <v-row class="mx-6">
              <v-col cols="5">
                <v-text-field
                  :value="agreementUpdateOn.replace('年', '/').replace('月', '/')"
                  label="前回契約更新日"
                  prepend-icon="mdi-calendar"
                  clearable
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="5" class="ml-4">
                <v-text-field
                  :value="agreementEndOn.replace('年', '/').replace('月', '/')"
                  label="契約満了日"
                  prepend-icon="mdi-calendar"
                  clearable
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
          </fieldset>

          <fieldset class="mt-10">
            <legend>詳細情報</legend>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-text-field
                  v-model="tel"
                  label="教室電話番号"
                  :counter="11"
                  :rules="rules.tel"
                  :disabled="!useStatus"
                >
                  <template #[`label`]>
                    教室電話番号 <font color="red">❇︎</font>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-text-field
                  v-model="representative"
                  label="教室担当者氏名"
                  :counter="20"
                  :rules="rules.classroomChargePerson"
                  :disabled="!useStatus"
                >
                  <template #[`label`]>
                    教室担当者氏名 <font color="red">❇︎</font>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="mx-6 mb-1">
              <v-col cols="12">
                <v-textarea
                  v-model="mail"
                  label="教室担当者メールアドレス"
                  :counter="100"
                  :rules="rules.mail"
                  :disabled="!useStatus"
                  rows=2
                  no-resize
                >
                  <template #[`label`]>
                    教室担当者メールアドレス <font color="red">❇︎</font>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </fieldset>
        <fieldset class="branch-fieldset" v-if="$store.state.apply.id &&  status === 'edit'">
          <legend>解約情報</legend>
          <p class="cancel__reason mb-0" style="display:inline-block">解約理由：</p>
          <div v-for="(reason, index) in cancellationReasons" :key="index">
            <p class="cancel__reason mb-0">・{{reason}}</p>
          </div>
          <p class="cancel__reason mt-2 mb-0" style="display:inline-block">解約申請者名：</p>
          <p class="cancel__name mb-0">{{cancellationApplicant}}</p>
          <v-btn class="mt-3 export__btn" small color="#4a81aa" dark @click.stop="download">エクセル出力</v-btn>
        </fieldset>

        </v-form>

        <v-btn v-if="useStatus" class="mt-10 ml-6" color="secondary" dark @click.stop="submit">保存</v-btn>

        <router-link to="/admin/school">
            <v-btn class="mt-10 ml-5" color="gray">塾情報編集に戻る</v-btn>
        </router-link>
      </template>
  </div>
</template>

<script>
import moment from 'moment'
import rules from '../../rules'
import DateTimePicker from '@/components/molecules/DateTimePicker'
import { saveAs } from 'file-saver'

export default {
  components: {
    DateTimePicker
  },
  data () {
    return {
      startMenu: false,
      endMenu: false,
      renewMenu: false,
      finishedMenu: false,
      startDateValid: true,
      rules: rules,
      // 教室情報
      className: this.$store.state.account.name,
      loginId: this.$store.state.account.login,
      password: this.$store.state.account.password,
      startDate: this.$store.state.account.useStartOn,
      endDate: this.$store.state.account.useEndOn,
      agreementUpdateOn: this.$store.state.account.agreementUpdateOn ? this.$store.state.account.agreementUpdateOn : '',
      agreementEndOn: this.$store.state.account.agreementEndOn ? this.$store.state.account.agreementEndOn : '',
      representative: this.$store.state.account.representative,
      tel: this.$store.state.account.tel,
      mail: this.$store.state.account.email,
      sendMail: this.$store.state.account.sendMail,
    }
  },

  beforeDestroy() {
    this.$store.commit('account/initialize', {})
  },

  watch: {
    startDate(newValue) {
      this.startDateValid = !!newValue
    }
  },

  computed: {
    classroomValid: {
      get() {
        return this.$store.state.school.classroomValid
      },
      set(value) {
        this.$store.commit('school/setclassroomValid', {
          valid: value
        })
      }
    },
    passwordLabel() {
      return this.$store.getters['account/passwordLabel']
    },
    code() {
      return this.$store.state.school.code //塾に設定された お客様No
    },
    name() {
      return this.$store.state.school.name //塾名
    },
    status() {
      return this.$store.state.account.status
    },
    passwordRules() {
      const rules = []
      // 新規作成の時はパスワードは必須項目
      if (!this.$store.state.account.id) {
        rules.push(v => !!v || 'パスワードを入力してください')
      }
      // パスワードが入力されていたらチェック
      if (this.password) {
        rules.push(v => v.length < 30 || 'パスワードは30文字以内で入力してください')
        rules.push(v => {
          const illegalChar = v.match(/[^a-zA-Z0-9!#$%&?@]/)
          return !illegalChar || `「${illegalChar[0]}」は使用できません`
        })
      }
      return rules
    },
    useStatus() {
      const current = moment()
      const isEdit = this.$store.getters['account/isEdit']
      let useStatus = false
      // 新規
      if(!isEdit){
        useStatus = true
      }
      // 解約
      if(!this.$store.state.account.useEndOn || (current.isBetween(this.startDate, this.$store.state.account.useEndOn))){
        useStatus = true
      }

      return useStatus
    },
    displayStartDate() {
      return moment(this.startDate).format('YYYY年M月D日 H:mm')
    },
    displayEndDate() {
      return moment(this.endDate).format('YYYY年M月D日 H:mm')
    },
    cancellationReasons() {
      return this.$store.state.apply.cancellationReasons
    },
    cancellationApplicant() {
      return this.$store.state.apply.cancellationApplicant
    },
  },

  methods: {
    async submit() {
      const classroomValid = this.$refs["classroom-form"].validate()
      this.$store.commit('account/setClassroomValid', { valid: classroomValid })
      this.startDateValid = !!this.startDate
      if (!classroomValid || !this.startDateValid) {
        this.$toasted.global.error({ message: '入力内容に不備があります。' })
        return
      }

      // メール送信（新規登録）にチェックが入ってればログインIDとパスワードは入力必須
      if (this.sendMail) {
        const mailValidate = !this.loginId || !this.password
        if (!this.loginId) this.$toasted.global.error({ message: 'ログインIDを入力してください' })
        if (!this.password) this.$toasted.global.error({ message: 'パスワードを入力してください' })
        if (mailValidate) return
      }

      this.$store.commit('account/setAccount', {
        name: this.className,
        login: this.loginId,
        password: this.password,
        useStartOn: this.startDate,
        useEndOn: this.endDate,
        agreementUpdateOn: this.agreementUpdateOn,
        agreementEndOn: this.endDate ? this.endDate : this.agreementEndOn,
        representative: this.representative,
        tel: this.tel,
        email: this.mail,
        sendMail: this.sendMail,
      })
      this.$emit('submit')
    },
    randomGenerate(type) {
      // ログインID、パスワードをランダムに生成
      // 【パスワード条件：半角英数字、半角記号!#$%&?@が使用可能、8文字】
      const availableMap = {
        loginId: "abcdefghjkmpqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ23456789",
        password: "abcdefghjkmpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!#$%&?@"
      }
      let random = Array.from(Array(availableMap[type].length)).map((v, index) => availableMap[type][index])
      random = this.shuffle(random).join('')
      this[type] = random.slice(0, 8)
    },
    shuffle([...array]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    getFileName(contentDisposition){
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      return fileName
    },
    async download(){
      const res = await this.$axios.get(`/api/v1/admin/requests/${this.$store.state.apply.id}/download_cancellation.xlsx`, { responseType: 'blob', dataType: 'binary' })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      const fileName = this.getFileName(contentDisposition)
      saveAs(blob, fileName)
    },
  },
}
</script>

<style lang="stylus" scoped>
fieldset
  margin 5px 23px
  width 95%
  padding 2px 15px 15px 15px
  border 1px solid #c6c6c6
  border-radius 5px

.select
  font-size 11px !important

.school-name
  display inline-block
  width 200px

</style>
